import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';
import type { GenericBody } from '@/app/KeywordTracker/types/keywordTrackerApiTypes';

const exportApi = keywordTrackerApi.injectEndpoints({
  endpoints: build => ({
    exportTable: build.mutation<unknown, GenericBody>({
      query: body => ({
        url: '/keyword_tracker/v2/export/',
        method: 'POST',
        body
      })
    })
  }),
  overrideExisting: false
});

export const { useExportTableMutation } = exportApi;
export default exportApi;
